import { defineNuxtPlugin } from '#app/nuxt'
import { LazyTableFilterBoolean, LazyTableFilterDate, LazyTableFilterNewFilterTemplate, LazyTableFilterNumeric, LazyTableFilterSearchSelect, LazyTableFilterSelect, LazyTableFilterString, LazyTableToolCategoriesCreate, LazyTableToolCategoriesDelete, LazyTableToolCostCentersCreate, LazyTableToolCostCentersDelete, LazyTableToolCostCentersStatus, LazyTableToolGeneralExport, LazyTableToolLoginProvidersCreate, LazyTableToolOrdersCreate, LazyTableToolOrdersCreateExpress, LazyTableToolOrdersCreateOrder, LazyTableToolOrdersCreateSpecial, LazyTableToolOrdersDelete, LazyTableToolOrdersExport, LazyTableToolOrganisationsCreate, LazyTableToolOrganisationsToggle, LazyTableToolUsersCreate, LazyTableToolUsersDelete, LazyDashboardWidgetDemoOpenAi, LazyDashboardWidgetGeneralTableIndex, LazyDashboardWidgetOrdersOrderStatus, LazyDashboardWidgetOrdersTenderStatus, LazyLogOrderApproved, LazyLogSelectedOffer, LazyLogSentMail, LazyLogStartTendering, LazyLogStatusUpdate, LazyLogUserLiked, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["TableFilterBoolean", LazyTableFilterBoolean],
["TableFilterDate", LazyTableFilterDate],
["TableFilterNewFilterTemplate", LazyTableFilterNewFilterTemplate],
["TableFilterNumeric", LazyTableFilterNumeric],
["TableFilterSearchSelect", LazyTableFilterSearchSelect],
["TableFilterSelect", LazyTableFilterSelect],
["TableFilterString", LazyTableFilterString],
["TableToolCategoriesCreate", LazyTableToolCategoriesCreate],
["TableToolCategoriesDelete", LazyTableToolCategoriesDelete],
["TableToolCostCentersCreate", LazyTableToolCostCentersCreate],
["TableToolCostCentersDelete", LazyTableToolCostCentersDelete],
["TableToolCostCentersStatus", LazyTableToolCostCentersStatus],
["TableToolGeneralExport", LazyTableToolGeneralExport],
["TableToolLoginProvidersCreate", LazyTableToolLoginProvidersCreate],
["TableToolOrdersCreate", LazyTableToolOrdersCreate],
["TableToolOrdersCreateExpress", LazyTableToolOrdersCreateExpress],
["TableToolOrdersCreateOrder", LazyTableToolOrdersCreateOrder],
["TableToolOrdersCreateSpecial", LazyTableToolOrdersCreateSpecial],
["TableToolOrdersDelete", LazyTableToolOrdersDelete],
["TableToolOrdersExport", LazyTableToolOrdersExport],
["TableToolOrganisationsCreate", LazyTableToolOrganisationsCreate],
["TableToolOrganisationsToggle", LazyTableToolOrganisationsToggle],
["TableToolUsersCreate", LazyTableToolUsersCreate],
["TableToolUsersDelete", LazyTableToolUsersDelete],
["DashboardWidgetDemoOpenAi", LazyDashboardWidgetDemoOpenAi],
["DashboardWidgetGeneralTableIndex", LazyDashboardWidgetGeneralTableIndex],
["DashboardWidgetOrdersOrderStatus", LazyDashboardWidgetOrdersOrderStatus],
["DashboardWidgetOrdersTenderStatus", LazyDashboardWidgetOrdersTenderStatus],
["LogOrderApproved", LazyLogOrderApproved],
["LogSelectedOffer", LazyLogSelectedOffer],
["LogSentMail", LazyLogSentMail],
["LogStartTendering", LazyLogStartTendering],
["LogStatusUpdate", LazyLogStatusUpdate],
["LogUserLiked", LazyLogUserLiked],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
